module.exports = __webpack_public_path__ + "static/breathwork-bd1420459faa9ed1fde1e4fb31c5f8b3.png";